import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {Group} from '@app/core/models/group.model';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

export interface IGroupsFilter {
	'filter[group_name]'?: string;
	'filter[department.id]'?: number | string;
	'include'?: string;
}

export interface IGroupFilter {
	'include'?: string;
	'append'?: number | string;
}

@Injectable()
export class GroupService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(params?): Group {
		if (!params) {
			return new Group(this.tenantTZ, this.interService);
		}

		return new Group(this.tenantTZ, this.interService).deserialize(params);
	}

	public getGroups(filters: IGroupsFilter = {}, page_size: number = 200, page: number = 1): Observable<Group[]> {
		const data = {
			...filters,
			page_size,
			page,
		};

		return this.httpService.getJson<Group[]>('groups', data).pipe(
			map((res: any) => res.data.map(group => new Group(this.tenantTZ, this.interService).deserialize(group)))
		);
	}
}
